module.exports = __webpack_public_path__ + "5ac3436215ed41a99e005f960e47ce58.jpg";